export default __webpack_public_path__ + "locales/vi/HotkeysPanel.json?hash=305e2d14acd4a19b7795673f448e85fb";